<template>
    <div class="sidebar-group" :class="{ 'sub-group': subGroup }">
        <div class="sidebar-group-header">
            <i class="fas float-left toggle-expanded" @click="expandedComputed = !expandedComputed"
               :class="[expandedComputed ? 'fa-chevron-up' : 'fa-chevron-down']" :disabled="!active"/>

            <slot name="actions"></slot>

            <component :is="subGroup ? 'h6' : 'h4'"><slot name="title">{{title|tr}}</slot></component>

            <slot name="append"></slot>
        </div>

        <div class="sidebar-group-body" v-if="active" v-show="expandedComputed" :class="{'pl-2': noLeftPadding}">
            <slot></slot>
        </div>
    </div>
</template>

<script>

// sidebar-group #hot-reload-debug
export default {
    name: `sidebar-group`,
    props: {
        title: {type: String},
        subGroup: {type: Boolean},
        active: {type: Boolean, default: true},
        width: {type: [Number, String]},
        noLeftPadding: {type: Boolean},
        expanded: {type: Boolean, default: null}
    },
    data() {
        return {
            fallbackExpanded: true
        }
    },
    computed: {
        expandedComputed: {
            get() {
                if (this.expanded === null) {
                    return this.fallbackExpanded;
                }
                return this.expanded;
            },
            set(value) {
                if (this.expanded === null) {
                    this.fallbackExpanded = value;
                }
                this.$emit(`update:expanded`, value);
            }
        }
    }
}
</script>

<style lang="scss">
.sidebar-group {
    border-bottom: var(--border-width) solid var(--border-color);

    .sidebar-group-header {
        padding: 5px 5px 5px 0;
        position: relative;
        clear: both;
        //padding: .5rem .5rem 0 1.7rem;
        //border-radius: var(--border-radius);

        h4, h5, h6 {
            margin: 0;
            display: inline-flex;
        }

        h4 {
            padding-left: 0px;
            font-size: 11pt;
            font-weight: 500;
            color: #000;
        }
        h5 {
            font-weight: 500;
            font-size: 12pt;
        }
        h6 {
            font-weight: 500;
            font-size: 11pt;
        }

        .custom-switch {
            position: relative;
            top: -3px;
            float: right;
        }
    }

    .sidebar-group-body {
        padding: 0 .5rem 0 1.75rem;
        position: relative;
        clear: both;
    }

    .toggle-expanded {
        top: -5px;
        margin-bottom: -5px;
        font-size: 14px;
        width: 24px;
        text-align: center;
        line-height: 34px;
        position: relative;
        opacity: 0.6;
        cursor: pointer;

        &:hover {
            color: #000;
            opacity: 1;
        }

        &[disabled] {
            opacity: 0;
        }
    }

    &.sub-group {
        background: rgba(white, 0.7);
        border: var(--border-width) solid var(--border-color);
        border-radius: var(--border-radius);
        margin-bottom: 0.75rem;

        .sidebar-group-header {
            border: none;
            background: transparent;
        }

        .sidebar-group-body {
            padding: .5rem .5rem 0 0.75rem;
        }
    }
}
</style>
